import { isGuest, isAuthed } from 'redux/query';

export const isRegisteredUser = (state) => !isGuest(state) && isAuthed(state);
